module.exports = {
      id: "telegram-usage",
      viewBox: "0 0 36 37",
      url: __webpack_public_path__ + "svg-sprite-0ef3134280a050ca46b4726dfe0fed42.svg#telegram",
      toString: function () {
        return this.url;
      }
    }